import React from "react";
import ContentStatusTable from "../../../components/Tables/ContentStatusTable";
import { useCourseContext } from "../../../contexts/CoursesContext";

export const ContentStatus = ({ style = {} }) => {
  const { contentStatuses } = useCourseContext();

  return (
    <div style={{ width: "100%", position: "relative", ...style }}>
      <ContentStatusTable contentStatuses={contentStatuses} />
    </div>
  );
};

export default ContentStatus;
